import type { BetLinesPort, CanvasTapTargets } from "@slot/game-shell";
import type { LineSelectorView } from "../../scene/LineSelectorView";

/**
 * The LINES selector (decision 56): ‹ takes a line away, › adds one, round the counts the operator offers — ‹ on the
 * fewest goes to the most, › on the most to the fewest (the user, 2026-10-06) — the shell's choice, under the bet
 * controls' rule (idle, the bet unlocked, no autoplay, no replay). While the lines cannot change both arrows dim, and a
 * tap on the selector is the scene's like any other (the shell's slam surface). The bonus plays no line: the selector is
 * gone while it plays.
 */
export class LineSelectorPresenter {
  private inBonus = false;

  public constructor(
    private readonly input: {
      view: LineSelectorView;
      betLines: BetLinesPort;
      canvasTaps: CanvasTapTargets;
    },
  ) {
    input.betLines.subscribe(() => this.render());
    input.canvasTaps.add((point) => this.tap(point));
    this.render();
  }

  /** The bonus starts or ends. */
  public setBonus(active: boolean): void {
    this.inBonus = active;
    this.render();
  }

  private render(): void {
    this.input.view.visible = !this.inBonus;
    if (this.inBonus) return;
    const { lines, options, canChange } = this.input.betLines.getSnapshot();
    const choosable = canChange && options.length > 1;
    this.input.view.setState({ lines, canDecrease: choosable, canIncrease: choosable });
  }

  private tap(point: { x: number; y: number }): boolean {
    if (this.inBonus) return false;
    const side = this.input.view.arrowAt(point);
    const { lines, options, canChange } = this.input.betLines.getSnapshot();
    if (side === null || !canChange || options.length === 0) return false;
    // Round the counts: past either end to the other.
    const at = Math.max(0, options.indexOf(lines));
    this.input.betLines.select(options[(at + side + options.length) % options.length]!);
    return true;
  }
}
